import { getHttpClient } from "@/core/api";

export async function getShippersWithTransports() {
  const response = await getHttpClient().get("v2/shipper/with-transports");
  return response.data;
}
